import { render, staticRenderFns } from "./AppPolygon.vue?vue&type=template&id=2b0b91d2&"
import script from "./AppPolygon.vue?vue&type=script&lang=js&"
export * from "./AppPolygon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports